/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Credits_SceneInputs */

const en_admin_credits_scene = /** @type {(inputs: Admin_Credits_SceneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scene`)
};

/**
* | output |
* | --- |
* | "Scene" |
*
* @param {Admin_Credits_SceneInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_credits_scene = /** @type {((inputs?: Admin_Credits_SceneInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Credits_SceneInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_credits_scene(inputs)
});
export { admin_credits_scene as "admin.credits.scene" }